<template>
  <div class="echarts" id="housingLeftThree">
    <div class="detial" :key="item.name" v-for="item in echartsList">
      <h-car-plate :colorData="colorDict" :type="item.plateColor" title="">{{
        item.plateNo
      }}</h-car-plate>

      <div>{{ item.carCount }}</div>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, onMounted } from "vue";
import moment from "moment";
import { getDict } from "@/api/constant";
import { frequencyAppearKey } from "@/api/publicSecurityResearch/keyCarPerson.js";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      echartsList: [],
      colorDict: [],
    });
    const refData = toRefs(data);
    // 获取数据字典
    const queryMenuType = async () => {
      const resCarColor = await getDict("car_card_color");
      data.colorDict = resCarColor.dict;
    };
    queryMenuType();
    const handleAnalysis = async () => {
      const form = {
        beginTime: moment(new Date().getTime() - 3600 * 1000 * 24 * 90).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        endTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      };
      const res = await frequencyAppearKey(form);
      if (res.code == 0) {
        data.echartsList = res.page.list.splice(0, 5);
      }
    };
    onMounted(() => {
      handleAnalysis();
    });
    return {
      ...refData,
    };
  },
});
</script>
<style lang="scss" scoped>
#housingLeftThree {
  width: 100%;
  height: 90%;
  overflow: auto;
  .detial {
    padding: 10px 30px 0 30px;
    display: flex;
    justify-content: space-between;
    .carNumber {
      // background: red;
      line-height: 32px;
      text-align: center;
      width: 120px;
      height: 32px;
      color: #fff;
      border-radius: 5px;
      div {
        border-radius: 5px;
        height: calc(100% - 2px);
        margin: 1px;
        width: calc(100% - 2px);
      }
    }
  }
}
</style>
